<template>
  <span>
    {{ formattedNumber }}
  </span>
</template>

<script>
import vueI18n from '@/plugins/i18n';

export default {
  name: 'animated-number',

  props: {
    value: Number,
    startAt: Number,
    delay: { type: Number, default: 300 },
    speed: { type: Number, default: 50 },
    randomStartsAt: { type: Number, default: 100 },
    format: { type: String, default: 'number' },
  },

  data() {
    return {
      step: 0,
      steps: null,
      MAX_STEP_PERCENTAGE: 0.1,
      currentNumber: this.startAt,
    };
  },

  computed: {
    number() {
      if (this.currentNumber > 999) {
        return Math.round(this.currentNumber / 100) / 10;
      }

      return Math.round(this.currentNumber);
    },

    formattedNumber() {
      if (this.format === 'time') {
        // will break if number > 3600. But that's okay for the average view time
        return (
          new Date(this.number * 1000).toISOString().substring(14, 19)
        );
      }
      return `${vueI18n.n(this.number)} ${this.suffix}`;
    },

    suffix() {
      return this.currentNumber > 999 ? 'k' : '';
    },
  },

  watch: {
    value() {
      this.stepNumber();
    },
  },

  created() {
    this.steps = this.delay / this.speed;
    this.stepNumber();
  },

  methods: {
    stepNumber() {
      if (!this.value) {
        this.currentNumber = 0;
      }

      if (this.currentNumber === this.value) {
        return;
      }

      if (typeof this.currentNumber !== 'number') {
        this.currentNumber = this.value || 0;
        return;
      }

      let stepWithPercentage;
      let targetValue;

      if (this.value) {
        this.step += 1;
        targetValue = this.value;
        stepWithPercentage = ((targetValue - this.currentNumber) / targetValue) / this.steps;
      } else {
        this.currentNumber = this.randomStartsAt;
        targetValue = this.currentNumber;
        stepWithPercentage = (Math.random() - 0.5) / 5;
      }

      this.currentNumber += stepWithPercentage * targetValue;

      setTimeout(this.stepNumber, this.speed);
    },
  },
};
</script>
